(function () {
    'use strict';

    angular
        .module('app')
        .directive('clickClose', clickClose);

    clickClose.$inject = ['$timeout'];

    function clickClose($timeout) {
        // Usage:
        //     <clickClose></clickClose>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                showElement: '=?'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            $(element).attr("id", "menucontainer");
            scope.$watch(function () {
                return scope.showElement;
            }, function (value) {
                if (value) {
                    $timeout(function () {
                        $(document).click(function (event) {
                            if (!$(event.target).closest('#menucontainer').length) {
                                scope.showElement = false;
                                scope.$apply();
                            }
                        });
                    });
                }
                else {
                    $(document).unbind("click");
                }
            })
        }
    }

})();